<div class="resetPasswordModal">
  <p-dialog [header]=" 'NEW.PASSWORD_COMPONENT.HEADER' | translate " [visible]="true" [draggable]="false"
            [closable]="false"
            [resizable]="false">

    <app-create-password (passwordEvent)="newPassword=$event" (verifyPasswordEvent)="verifyPassword=$event"
                         (isNewPasswordValid)="isNewPasswordValid=$event" (isNewPasswordConfirmValid)="isNewPasswordConfirmValid=$event"></app-create-password>
    <div class="grid">
      <div class="col-12 center error">
        <p >{{errorMessage}}</p>
        <p *ngIf="!isNewPasswordValid" >{{passwordInvalidMsg}}</p>
        <p *ngIf="!isNewPasswordConfirmValid" >{{passwordConfirmInvalidMsg}}</p>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 center validation-div">
        <button pButton type="button" (click)="createNewPassword()"
                [label]="'NEW.PASSWORD_COMPONENT.VALIDATION_BUTTON' | translate"
                [disabled]="!(isNewPasswordValid && isNewPasswordConfirmValid)" class="p-button-success"></button>
      </div>
    </div>
  </p-dialog>
</div>
